import { render, staticRenderFns } from "./BeforePos.vue?vue&type=template&id=fff1f048&scoped=true"
import script from "./BeforePos.vue?vue&type=script&lang=js"
export * from "./BeforePos.vue?vue&type=script&lang=js"
import style0 from "./BeforePos.vue?vue&type=style&index=0&id=fff1f048&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff1f048",
  null
  
)

export default component.exports